document.addEventListener('DOMContentLoaded', () => {
    const fileUploads = document.querySelectorAll('.file-upload');
    
    fileUploads.forEach(fileUpload => {
        const fileInput = fileUpload.querySelector('.file-input');
        const textInput = fileUpload.querySelector('input[type="text"]');
        
        fileUpload.addEventListener('click', () => {
            fileInput.click();
        });
        
        fileInput.addEventListener('change', () => {
            if (fileInput.files.length > 0) {
                textInput.value = fileInput.files[0].name;
            }
        });
    });
});